import { SoilAnalysis } from '../models/soil-analysis.model';

export class SoilAnalysisTitleHelper {
  static getSoilAnalysisTitle(soilAnalysis: SoilAnalysis): string {
    if (!soilAnalysis.labId) {
      return soilAnalysis.description;
    }
    return `${soilAnalysis.labId} - ${soilAnalysis.description}`;
  }
}
